export default {
  title: "Tipo"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
    , canales: {
      label: "Canales"
      , th: "Canales"
    }
    , localizacion: { label: "Validar datos de localización" }
    , contacto: { label: "Validar datos de contacto" }
    , adicional: { label: "Validar datos adicionales" }
  }
  , errors: {
    BD5008: { text: "Ocurrió un error en el catálogo de Tipo" }
    , WS5008: { text: "Ocurrió un error en el catálogo de Tipo" }
    , JS5008: { text: "Ocurrió un error en el catálogo de Tipo" }
    , CR5008: { text: "Ocurrió un error en el catálogo de Tipo" }
    , UK_Tipo: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/tipo.js